
<div class="landing-hero-banner">
  <div class="landing-hero-banner__content">
    <h1 class="landing-hero-banner__content-title">
      <div class="title-1">
        <span class="shoot">{{ 'landing.shoot' | transloco }}</span>
        <img src="assets/images/icon-512.png"/>
      </div>
      <span>{{ 'landing.we-handle-the-rest' | transloco }}</span>
    </h1>

    <div class="landing-hero-banner__content-features">
      <p class="feature">{{ 'landing.features.bookings' | transloco }}</p>
      <p class="feature">{{ 'landing.features.online-payment' | transloco }}</p>
      <p class="feature">{{ 'landing.features.pro-galleries' | transloco }}</p>
      <p class="feature feature--total">{{ 'landing.features.all-in-one' | transloco }}</p>
    </div>

    <div class="landing-hero-banner__animation">
      <div class="window">
        <img src="assets/images/landing/product.png" alt="Shutterflow"/>
      </div>

      <a class="button button--large"
         [routerLink]="'/register'"
         (click)="trackHeroCta()"
      >
        {{ 'landing.try-now' | transloco }}
        <i class="fa-solid fa-arrow-right"></i>
      </a>
    </div>
  </div>
</div>
